import { Reveal } from "./Motion";

const FACTS = [
    { icon: "🌱", body: "Paper comes from renewable fibre when responsibly sourced." },
    { icon: "♻️", body: "Recycling depends on local waste-management systems." },
    { icon: "💧", body: "Aqueous coatings are water-based barrier coatings developed as alternatives to traditional plastic linings in many food packaging applications." },
    { icon: "📦", body: "Different packaging materials are appropriate for different food, shelf-life and performance requirements." },
];

export default function DidYouKnow() {
    return (
        <section className="bg-sand border-y border-forest" data-testid="did-you-know">
            <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
                <Reveal>
                    <div className="grid lg:grid-cols-12 gap-8 mb-14">
                        <div className="lg:col-span-4 font-mono text-xs uppercase tracking-widest text-stone">[ Chapter 05 · Field Notes ]</div>
                        <h2 className="lg:col-span-8 font-serif text-5xl lg:text-7xl leading-[1] tracking-tight text-forest">
                            Did you <em className="italic">know?</em>
                        </h2>
                    </div>
                </Reveal>

                <div className="grid md:grid-cols-2 gap-0 border-t border-l border-forest/40">
                    {FACTS.map((f, i) => (
                        <Reveal key={i} delay={i * 0.05}>
                            <div className="border-r border-b border-forest/40 p-8 lg:p-12 h-full flex gap-6" data-testid={`fact-${i}`}>
                                <div className="text-4xl lg:text-5xl select-none" aria-hidden>{f.icon}</div>
                                <p className="text-base lg:text-lg text-inkgreen/85 leading-relaxed font-serif">{f.body}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <div className="mt-10 max-w-3xl">
                    <p className="text-xs font-mono uppercase tracking-widest text-stone">
                        Sources: Confederation of European Paper Industries · CPCB India · FAO
                    </p>
                </div>
            </div>
        </section>
    );
}
